import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["onTouchstart", "onTouchmove", "onTouchend", "onMousedown", "onMousemove", "onMouseup", "onMouseleave"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["toast-container", { mobile: _ctx.isMobile }])
  }, [
    _createVNode(_TransitionGroup, { name: "toast" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toasts, (toast) => {
          return (_openBlock(), _createElementBlock("div", {
            key: toast.id,
            class: "toast-wrapper"
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["toast", [toast.type, { dragging: _ctx.dragState[toast.id]?.dragging }]]),
              style: _normalizeStyle(_ctx.getToastStyle(toast)),
              onTouchstart: ($event: any) => (_ctx.startDrag(toast.id, $event.touches[0].clientX)),
              onTouchmove: ($event: any) => (_ctx.moveDrag(toast.id, $event.touches[0].clientX)),
              onTouchend: ($event: any) => (_ctx.endDrag(toast.id)),
              onMousedown: _withModifiers(($event: any) => (_ctx.startDrag(toast.id, $event.clientX)), ["prevent","stop"]),
              onMousemove: _withModifiers(($event: any) => (_ctx.moveDrag(toast.id, $event.clientX)), ["prevent","stop"]),
              onMouseup: _withModifiers(($event: any) => (_ctx.endDrag(toast.id)), ["prevent","stop"]),
              onMouseleave: _withModifiers(($event: any) => (_ctx.endDrag(toast.id)), ["prevent","stop"])
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.renderContent(toast.content)), {
                class: "toast-notification-component",
                ref_for: true,
                ref: (el) => { if (el) _ctx.toastContent[toast.id] = el }
              }, null, 512))
            ], 46, _hoisted_1)
          ]))
        }), 128))
      ]),
      _: 1
    })
  ], 2))
}